import styled from 'styled-components/macro';
import Button from './Button';

const ButtonCancel = styled(Button)`
  color: #109cf1;
`;

export default ButtonCancel;
